import { Link } from 'react-router-dom';
import Footer from './Footer';
import { ReactComponent as Logo } from '../censuszen-logo.svg';
import '../styles/LegalPage.css';
import '../styles/PricingPage.css';

export const PricingPage = () => (
    <div className="legal-page">
        <nav className="legal-nav">
            <Link to="/">
                <Logo className="legal-nav-logo" aria-label="CensusZen" />
            </Link>
            <div className="legal-nav-links">
                <Link to="/login" className="legal-nav-link legal-nav-link--ghost">
                    Log in
                </Link>
                <Link to="/register" className="legal-nav-link legal-nav-link--solid">
                    Sign Up
                </Link>
            </div>
        </nav>

        <main className="legal-body">
            <div className="legal-card pricing-card">
                <h3>Try it before we talk price</h3>
                <p className="pricing-lede">
                    We are still working out pricing. Until it is set, we would rather show you
                    CensusZen on your own referral packets. Plans are per agency. An individual
                    tier may come later. A business associate agreement is available to every
                    customer. Once pricing is set, plans will be month to month.
                </p>

                <h4>What every agency gets</h4>
                <ul className="pricing-list">
                    <li>The pre-start-of-care eligibility report</li>
                    <li>The RN pre-visit briefing</li>
                    <li>PDGM-ready diagnosis code suggestions</li>
                    <li>Unlimited uploads during the trial</li>
                    <li>The security overview on request</li>
                </ul>

                <div className="pricing-actions">
                    <Link to="/request-access?source=trial_request" className="pricing-btn pricing-btn--primary">
                        Contact us for a free trial
                    </Link>
                    <Link to="/request-access?source=demo_request" className="pricing-btn pricing-btn--secondary">
                        Book a demo
                    </Link>
                </div>
            </div>
            <div className="legal-back">
                <svg className="legal-back-arrow" width="14" height="14" viewBox="0 0 16 16" fill="none" aria-hidden="true">
                    <path d="M10 12L6 8L10 4" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
                <Link to="/">Back to home</Link>
            </div>
        </main>

        <Footer variant="legal" />
    </div>
);
